import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AudioData } from '../models/audio-data';

@Injectable({
  providedIn: 'root'
})
export class AudioDataService {
  data: BehaviorSubject<AudioData | null> = new BehaviorSubject<AudioData | null>({} as AudioData);
  isPlay: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  currentData = this.data.asObservable();
  currentStatus = this.isPlay.asObservable();

  updateAudio(newData: AudioData | null): void {
    this.data.next(newData);
  }

  updateAudioStatus(isPlay: boolean): void {
    this.isPlay.next(isPlay);
  }
}
